import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';


import MainContent from '../../components/mainContent/MainContent';
import Termino from './components/Termino';

export default function Terminos() {

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const QTermino = gql`
        query QTermino($idUsuario: Int!){
            terminoUsuario (idUsuario: $idUsuario) 
            {
                success,
                error,
                valorEsperado {
                    idTermino,
                    idUsuario,
                    texto,
                    vigenciaDesde,
                    vigenciaHasta,
                    fecha
                }
            }
        }`;

  const { loading, error, data } = useQuery(QTermino, {
    fetchPolicy: 'no-cache',
    variables: { "idUsuario": idUsuario }
  });

  if (loading) return <MainContent component={<CircularProgress disableShrink />} titulo='Términos y Condiciones' />;
  if (error) return `Error! ${error.message}`;

  if (data) {
    return (
      <MainContent component={<Termino data={data} toolbar={false} />} titulo='Términos y Condiciones' />);

  }
};